import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import AssetsHome from '../views/AssetsHome';
import Orders from '../views/Orders';
import Availability from '../views/Availability';
// import Quality from '../views/Quality';
import Profile from '../views/Profile';
import HelpCenter from '../views/HelpCenter';
import PrivacyPolicy from '../views/PrivacyPolicy';
import Dimensioning from '../views/Dimensioning';
import Results from '../views/Results';
import Home from '../views/Home';
import Loading from '../components/utils/Loading';
import NotFound from '../views/NotFound';

const DashboardRoutes: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route path="/dashboard">
        <Dashboard>
          <Route exact path="/dashboard" component={Home} />
          <Route exact path="/dashboard/monitoramento" component={AssetsHome} />
          <Route
            exact
            path="/dashboard/monitoramento/ordens-de-servico"
            component={Orders}
          />
          <Route
            exact
            path="/dashboard/monitoramento/disponibilidade"
            component={Availability}
          />
          {/* <Route exact path="/dashboard/monitoramento/qualidade" component={Quality} /> */}
          <Route
            exact
            path="/dashboard/planejamento/efetivo"
            component={Dimensioning}
          />
          <Route
            exact
            path="/dashboard/analise/resultados"
            component={Results}
          />
          <Route
            exact
            path="/dashboard/configuracoes/perfil"
            component={Profile}
          />
          <Route
            exact
            path="/dashboard/central-de-ajuda"
            component={HelpCenter}
          />
          <Route
            exact
            path="/dashboard/politica-de-privacidade"
            component={PrivacyPolicy}
          />
          {/* <Route path={'/dashboard/*'}>
            <NotFound />
          </Route> */}
        </Dashboard>
      </Route>
      <Route exact path="/">
        <Redirect to="/dashboard" />
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch>
  </Suspense>
);

export default DashboardRoutes;
